import { render, staticRenderFns } from "./WrapperArrows.vue?vue&type=template&id=446982f4&"
import script from "./WrapperArrows.vue?vue&type=script&lang=ts&"
export * from "./WrapperArrows.vue?vue&type=script&lang=ts&"
import style0 from "./WrapperArrows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports